(() => {
    class BrandsService {
        constructor($q, APIService) {
            this._q = $q;
            this.apiService = APIService;
        }

        fetchBrandById(id) {
            const deferred = this._q.defer();
            this.apiService.Brands.getBrandByBrandId(id)
                .then((response) => deferred.resolve(response.data))
                .catch((error) => deferred.reject(error));
            return deferred.promise;
        }
    }

    angular.module("dashboard")
        .service("BrandsService", [ "$q", "APIService", BrandsService ])
})();
